import React, { useState, useEffect } from 'react';
import { FiPlay } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const navLinks = [
  { label: 'Verticals', href: '#niches' },
  { label: 'Call Types', href: '#call-types' },
  { label: 'Metrics', href: '#metrics' },
  { label: 'Contact', href: '#contact' },
];

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-slate-950/80 backdrop-blur-xl py-4' : 'bg-transparent py-8'}`}>
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center transform rotate-12">
            <SafeIcon icon={FiPlay} className="text-white text-sm fill-current" />
          </div>
          <span className="text-white font-black text-2xl tracking-tighter italic">VIDEONATION</span>
        </div>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-slate-400 hover:text-white text-sm font-bold uppercase tracking-widest transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>

        <a
          href="#contact"
          className="bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-black uppercase tracking-widest px-5 py-3 rounded-xl transition-colors"
        >
          Get Started
        </a>
      </div>
    </nav>
  );
};

export default Navbar;